import { axiosInstance } from "@/lib/axios";
import {
    LoginPayload,
    RegisterPayload,
    AuthResponse,
    User,
} from "@/types/auth.types";

export const loginApi = async (
    payload: LoginPayload
): Promise<AuthResponse> => {
    const { data } = await axiosInstance.post("/auth/login", payload);
    return data;
};

export const registerApi = async (
    payload: RegisterPayload
): Promise<AuthResponse> => {
    const { data } = await axiosInstance.post("/auth/register", payload);
    return data;
};

export const getMeApi = async (): Promise<{ user: User }> => {
    const { data } = await axiosInstance.get("/auth/me");
    // Some endpoints may return { success, data: { user } }, others { user }
    const user = data?.user || data?.data?.user;
    return { user };
};

export const logoutApi = async (): Promise<void> => {
    await axiosInstance.post("/auth/logout");
};
